import { RootState } from '../../store/rootReducer';
import { LocalConfigSchema } from '../../@types/data';

export const getCurrentConfig = (state: RootState): LocalConfigSchema => state.config.current;
